export default "__VITE_ASSET__HP9IKglo__"